export default {
  GettingStarted: 'Bắt đầu sử dụng',
  Greeting: 'Xin chào {0}!',
  InitGuide_1: 'Trước khi bắt đầu hạch toán trên phần mềm',
  InitGuide_2: 'hãy bắt đầu thiết lập thông tin và số liệu kế',
  InitGuide_3: 'toán ban đầu',

  BtnViewTemplateData: 'XEM DỮ LIỆU MẪU',
  ProductIntro: 'Giới thiệu sản phẩm',
  BtnDeclare: 'KHAI BÁO NGAY',

  InitBalance: 'Nhập số dư ban đầu',
  InitBalanceDesc_1: 'Nhập số dư tài khoản, số dư ban',
  InitBalanceDesc_2: 'đầu CCDC, VTHH...',

  AccountSystemSetting: 'Thiết lập hệ thống tài khoản',
  AccountSystemSettingDesc_1: 'Thêm tài khoản hạch toán, thiết lập',
  AccountSystemSettingDesc_2: 'theo dõi chi tiết...',

  UserManage: 'Quản lý người dùng',
  UserManageDesc_1: 'Thêm danh sách người dùng và',
  UserManageDesc_2: 'thiết lập vai trò quyền hạn',
};
